import React from 'react';
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
} from 'react-simple-maps';
import styled from 'styled-components';

const GEO_URL = 'https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json';

// States with presence
const ACTIVE_STATES = ['California', 'Oklahoma', 'Kansas', 'Texas'];

// Approx centroids for pins
const markers = [
  { name: 'California', coords: [-119.4, 37.2] },
  { name: 'Texas',      coords: [-99.3,  31.5] },
  { name: 'Oklahoma',   coords: [-97.5,  35.5] },
  { name: 'Kansas',     coords: [-98.4,  38.5] },
];

const MapWrap = styled.div`
  position: relative;
  width: 100%;
`;

export function UsaMap() {
  const mapRef = React.useRef(null);

  return (
    <div ref={mapRef} style={{ position: 'relative', width: '100%' }}>
      <ComposableMap
        projection="geoAlbersUsa"
        style={{ width: '100%', height: 'auto' }}
      >
        <Geographies geography={GEO_URL}>
          {({ geographies }) =>
            geographies.map((geo) => {
              const isActive = ACTIVE_STATES.includes(geo.properties.name);
              return (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  style={{
                    default: {
                      fill: isActive ? 'rgba(192,112,32,0.30)' : 'rgba(26,18,8,0.07)',
                      stroke: isActive ? 'rgba(124,58,0,0.40)' : 'rgba(26,18,8,0.15)',
                      strokeWidth: isActive ? 1 : 0.5,
                      outline: 'none',
                    },
                    hover: {
                      fill: isActive ? 'rgba(192,112,32,0.52)' : 'rgba(26,18,8,0.10)',
                      stroke: isActive ? '#7C3A00' : 'rgba(26,18,8,0.20)',
                      strokeWidth: isActive ? 1.2 : 0.5,
                      outline: 'none',
                    },
                    pressed: { outline: 'none' },
                  }}
                />
              );
            })
          }
        </Geographies>

        {markers.map(({ name, coords }) => (
          <Marker key={name} coordinates={coords}>
            {/* State name label */}
            <text
              textAnchor="middle"
              y={-22}
              style={{
                fontFamily: "'Raleway', serif",
                fontSize: '16px',
                fontWeight: '600',
                letterSpacing: '0.1em',
                fill: '#7C3A00',
                paintOrder: 'stroke',
                stroke: 'rgba(255,253,247,0.9)',
                strokeWidth: '4px',
                strokeLinejoin: 'round',
                pointerEvents: 'none',
                userSelect: 'none',
              }}
            >
              {name}
            </text>
            {/* Pulse ring */}
            <circle r={10} fill="rgba(192,112,32,0.20)" style={{ pointerEvents: 'none' }} />
            {/* Pin dot */}
            <circle r={6} fill="#C07020" stroke="#FFFDF7" strokeWidth={2} style={{ pointerEvents: 'none' }} />
          </Marker>
        ))}
      </ComposableMap>
    </div>
  );
}
